import axios from "axios";
import { findPropObject, handlerError } from "utils";
import { notification } from "antd";
import moment from "moment";


export const getAllCompanies = async (filter) => {
    try {
        const res = await axios.get(`/company`,{params:{filter}});
        return res.data?.companies ?? [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const getCompany = async (company) => {
    try {
        const res = await axios.get(`/company${company ? '/' + company : '/current'}`);
        return res.data.data ? res.data.data : {};
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const getCompanySolicitations = async ({companyID, page = 1, pageSize = 10, filter = null, dates = null, listAll = false, sorter = null, types = null, benefits = null, status = null}) => {
    try {
        const { data } = await axios.get(`/company/${companyID}/solicitations`, {
            params: {
                ...(filter ? { filter: filter.trim() } : {}),
                ...(dates ? { dates: dates } : {}),
                page: page,
                size: pageSize,
                listAll: listAll,
                ...(sorter ? { sorter: sorter } : {}),
                ...(types ? { types: types } : {}),
                ...(benefits ? { benefits: benefits } : {}),
                ...(status ? { status: status } : {}),
            }
        });
        return data;
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};


export const getCompanyByDocument = async (document) => {
    try {
        const res = await axios.get(`/company?cnpj=${document}`);
        return res.data.companies ? res.data.companies : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const getAllChildrenCompanies = async (withParents = true) => {
    try {
        const { data } = await axios.get(`/company/children`, { params: { withParents: withParents } });
        return data.companies || [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const search = async (search) => {
    try {
        const res = await axios.get(`/company/search`, { params: { query: search } });
        return res.data.companies;
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const getTotalBalance = async (company = null, system) => {
    try {
        const { data } = await axios.post(`/company${company ? "/" + company : ""}/totalBalance`, {}, company ? undefined : { params: { system: system } });
        return data ? data : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getRewardBalance = async (company = null) => {
    try {
        const { data } = await axios.post(`/company${company ? "/" + company : ""}/rewardBalance`, {});
        return data ? data : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getStatement = async (system) => {
    try {
        const { data } = await axios.get(`/company/statement`, { params: { system: system } });
        return data.transactions;
    } catch (ex) {
        handlerError(ex);
        return [];
    }
}

export const getCompanyBenefits = async (allBalance = false) => {
    try {
        const { data } = await axios.get(`/company/benefit`, { params: { allBalance: allBalance } });
        return data.benefits ? data.benefits : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
}

export const getPendingCharges = async () => {
    try {
        const { data } = await axios.get(`/company/charge`, { params: { pending: true } });
        return data && data.charges ? data.charges : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
}

export const getPendingSolicitation = async (company) => {
    try {
        const { data } = await axios.get(`/company/${company}/solicitation/pending`);
        return data && data.data ? data.data : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
}

export const getAllParentManagers = async (id, isChildren = false) => {
    try {
        const res = await axios.get(isChildren ? `/company/parent/manager?matriz=${id}` : `/company/${id}/parent/manager`);
        return res.data ? res.data.data : []
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const saveParentManagers = async (company, list) => {
    try {
        const req = {
            data: list
        }
        await axios.put(`/company/${company}/parent/manager`, req);
        notification.success({
            message: "Salvo com sucesso"
        })
    } catch (ex) {
        handlerError(ex);
        throw (null);
    }
};

export const getAllParentAdministrator = async (id) => {
    try {
        const res = await axios.get(`/company/${id}/parent/administrator`);
        return res.data ? res.data.data : []
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};

export const saveParentAdministrator = async (company, list) => {
    try {
        const req = {
            data: list
        }
        await axios.put(`/company/${company}/parent/administrator`, req);
        notification.success({
            message: "Salvo com sucesso"
        })
    } catch (ex) {
        handlerError(ex);
        throw (null);
    }
};

export const saveCompany = async (id = null, body) => {
    try {
        const req = {
            data: {
                ...body,
                foundedAt: moment(body.foundedAt).format('YYYY-MM-DD'),
                firstContractAt: body.firstContractAt ? moment(body.firstContractAt).format('YYYY-MM-DD') : null,
                benefit: findPropObject(body, ["benefit", "id"]) ? body.benefit : null,
                matriz: findPropObject(body, ["matriz", "id"]) ? body.matriz : null,
                partnership: findPropObject(body, ["partnership", "id"]) ? body.partnership : null,
                businessType: findPropObject(body, ["businessType", "code"]) ? body.businessType : null,
                bankAccount: {
                    ...body.bankAccount,
                    bank: findPropObject(body, ["bankAccount", "bank", "code"]) ? body.bankAccount.bank : null,
                    type: findPropObject(body, ["bankAccount", "type", "code"]) ? body.bankAccount.type : null
                },
                segmentations: body.segmentations && body.segmentations.length > 0
                    ? body.segmentations.map(b => ({
                        benefit: b.benefit,
                        enabled: b.enabled,
                        spending: b.companySpending,
                        minimumValue: b.minimumValue,
                        completeBalance: b.completeBalance,
                        corporateRefund: b.corporateRefund,
                        manager: b.manager ? b.manager.id : null
                    }))
                    : undefined
            }
        }
        let res = null;
        if (id) {
            res = await axios.put(`/company/${id}`, req);
        } else {
            res = await axios.post(`/company`, req);
        }
        notification.success({
            message: "Dados da empresa salvo com sucesso!"
        })
        return res.data ? res.data : {}
    } catch (ex) {
        handlerError(ex);
        throw (null);
    }
};

export const getCompanyShareholder = async (company) => {
    try {
        const { data } = await axios.get(`/company/${company}/shareholders`);
        return data && data.shareholders ? data.shareholders : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
}

export const saveCompanyShareholder = async (id, values, valuesCompany) => {
    try {
        if (values.birthday) {
            values.birthday = moment(values.birthday).format('yyyy-MM-DD')
        }
        const req = {
            shareholder: values
        }
        if (valuesCompany) {
            valuesCompany?.bankAccount?.account?.numberWithDigit && delete valuesCompany.bankAccount.account.numberWithDigit;
            valuesCompany?.bankAccount?.branch?.numberWithDigit && delete valuesCompany.bankAccount.branch.numberWithDigit;
            valuesCompany?.kycStatus && delete valuesCompany.kycStatus;
            valuesCompany?.kycUpdatedStatusAt && delete valuesCompany.kycUpdatedStatusAt
            await saveCompany(id, valuesCompany);
        }
        await axios.post(`/company/${id}/shareholders`, req);
        return true;
    } catch (ex) {
        handlerError(ex);
        return false;
    }
}

export const sendBiometricEmailToShareholder = async (companyId, shareholderID) => {
    try {
        await axios.post(`/company/${companyId}/shareholder/${shareholderID}/biometric/send`, {});
        return true;
    } catch (ex) {
        handlerError(ex);
        return false;
    }
}

export const getBiometricUrl = async (token) => {
    try {
        const res = await axios.post(`/company/shareholder/${token}`, {});
        return {
            url: res.data.url
        };
    } catch (ex) {
        handlerError(ex);
        return false;
    }
}

export const updateCompanyShareholder = async (companyID, shareholderID, shareholder, valuesCompany) => {
    try {
        if (shareholder.birthday) {
            shareholder.birthday = moment(shareholder.birthday).format('yyyy-MM-DD');
        }
        const req = {
            shareholder: shareholder
        }

        if (valuesCompany) {
            valuesCompany?.bankAccount?.account?.numberWithDigit && delete valuesCompany.bankAccount.account.numberWithDigit;
            valuesCompany?.bankAccount?.branch?.numberWithDigit && delete valuesCompany.bankAccount.branch.numberWithDigit;
            valuesCompany?.kycStatus && delete valuesCompany.kycStatus;
            valuesCompany?.kycUpdatedStatusAt && delete valuesCompany.kycUpdatedStatusAt
            await saveCompany(companyID, valuesCompany);
        }

        await axios.put(`/company/${companyID}/shareholders/${shareholderID}`, req);
        return true;
    } catch (ex) {
        handlerError(ex);
        return false;
    }
}

export const deleteCompanyShareholder = async (shareholder) => {
    try {
        await axios.delete(`/company/shareholders/${shareholder}`);
    } catch (ex) {
        handlerError(ex);
    }
}

export const getCompanyKycStatus = async (company) => {
    try {
        const { data } = await axios.get(`/company/${company}/kycStatus`);
        return data ? data.data : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const getCompanyActivation = async (company) => {
    try {
        const { data } = await axios.get(`/company/${company}/activation`, {});
        return data && data.step !== null ? (data.step - 1) : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
}

export const getInvoiceTransactions = async (date) => {
    try {
        const { data } = await axios.get(`/company/transactionsInvoice?date=${date}`, {});
        return data ? data.data : null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
}

export const getCompanyEmployeesByFilter = async ({companyID, filter = null, page = 1, pageSize = 10, listAll = false}) => {
    try {
        const { data } = await axios.get(`/company/${companyID}/employees`, {
        params: {
            ...(filter ? { filter: filter.trim() } : {}),
            page: page,
            size: pageSize,
            listAll,
        }
        });
        return data;
    } catch (ex) {
        handlerError(ex);
        return [];
    }
};
